import { useEffect, useState } from "react";
import { FaClock } from "react-icons/fa";
import { estaCerradoCaraballeda } from "./Utils/horariosSucursal";

const EtiquetaEstadoSucursal = () => {
  const [cerrado, setCerrado] = useState(() => estaCerradoCaraballeda());

  useEffect(() => {
    const actualizar = () => setCerrado(estaCerradoCaraballeda());
    actualizar();
    const intervalo = setInterval(actualizar, 60_000);
    return () => clearInterval(intervalo);
  }, []);

  return (
    <div
      className={`fixed bottom-4 left-4 z-40 flex h-14 items-center gap-2.5 px-4 rounded-full pointer-events-none shadow-md ${
        cerrado
          ? "bg-gradient-to-tr from-red-600 to-red-500 text-white"
          : "bg-gradient-to-tr from-emerald-600 to-emerald-500 text-white"
      }`}
      aria-live="polite"
      aria-label={cerrado ? "Sucursal cerrada" : "Sucursal abierta"}
    >
      <span
        className={`flex h-2 w-2 shrink-0 rounded-full animate-pulse ${
          cerrado ? "bg-red-200" : "bg-emerald-200"
        }`}
        aria-hidden="true"
      />
      <FaClock className="shrink-0 text-[13px] opacity-90" aria-hidden="true" />
      <span className="text-[11px] font-bold uppercase tracking-[0.14em]">
        {cerrado ? "Cerrado" : "Abierto"}
      </span>
    </div>
  );
};

export default EtiquetaEstadoSucursal;
